// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
	--sapElement_BorderCornerRadius: 0.75rem;
	--sapGroup_ContentBackground: #fff;
	--sapGroup_ContentBorderColor: #d9d9d9;
	--sapGroup_TitleBackground: #fff;
	--sapButton_BorderColor: #bcc3ca;
}

.QSIWebResponsive div[role='dialog'] {
	background: var(--sapGroup_ContentBackground) !important;
	border-radius: var(--sapElement_BorderCornerRadius) !important;
}

.Skin #Header {
	font-family: sapFontBlackFamily, Arial, Helvetica, sans-serif;
	font-size: 20px !important;
}

.Skin #HeaderContainer {
	border-bottom: none !important;
}

div#Wrapper {
	border-color: var(--sapGroup_ContentBorderColor) !important;
	border: 1px solid var(--sapGroup_ContentBorderColor) !important;
}

div#HeaderContainer {
	background: var(--sapGroup_TitleBackground) !important;
}

html.JFEScope.iOSSIFix {
	border: 1px solid var(--sapButton_BorderColor) !important;
}
`, "",{"version":3,"sources":["webpack://./src/api/theming/theme.module.lazy.css"],"names":[],"mappings":"AAAA;CACC,wCAAwC;CACxC,kCAAkC;CAClC,sCAAsC;CACtC,gCAAgC;CAChC,gCAAgC;AACjC;;AAEA;CACC,wDAAwD;CACxD,8DAA8D;AAC/D;;AAEA;CACC,6DAA6D;CAC7D,0BAA0B;AAC3B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,2DAA2D;CAC3D,+DAA+D;AAChE;;AAEA;CACC,sDAAsD;AACvD;;AAEA;CACC,yDAAyD;AAC1D","sourcesContent":[":root {\n\t--sapElement_BorderCornerRadius: 0.75rem;\n\t--sapGroup_ContentBackground: #fff;\n\t--sapGroup_ContentBorderColor: #d9d9d9;\n\t--sapGroup_TitleBackground: #fff;\n\t--sapButton_BorderColor: #bcc3ca;\n}\n\n.QSIWebResponsive div[role='dialog'] {\n\tbackground: var(--sapGroup_ContentBackground) !important;\n\tborder-radius: var(--sapElement_BorderCornerRadius) !important;\n}\n\n.Skin #Header {\n\tfont-family: sapFontBlackFamily, Arial, Helvetica, sans-serif;\n\tfont-size: 20px !important;\n}\n\n.Skin #HeaderContainer {\n\tborder-bottom: none !important;\n}\n\ndiv#Wrapper {\n\tborder-color: var(--sapGroup_ContentBorderColor) !important;\n\tborder: 1px solid var(--sapGroup_ContentBorderColor) !important;\n}\n\ndiv#HeaderContainer {\n\tbackground: var(--sapGroup_TitleBackground) !important;\n}\n\nhtml.JFEScope.iOSSIFix {\n\tborder: 1px solid var(--sapButton_BorderColor) !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
